import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upolicy',
  templateUrl: './upolicy.component.html',
  styleUrls: ['./upolicy.component.css']
})
export class UpolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
